import React from 'react'
import {
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  BarChart,
  Bar,
  LabelList,
} from 'recharts'

const Top10Graph = ({ data = [], orgs = [] }) => {
  if (!data.length) return <div>No data</div>

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={data.slice(0, 10)}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="email"
          interval={0}
          tickFormatter={(value) =>
            orgs.length ? orgs.find((org) => org._id === value)?.label : value?.split?.('@')[0]
          }
          angle={-45}
          textAnchor="end"
          height={100}
        />
        <YAxis />
        <Tooltip />
        <Bar dataKey="count" fill="#8884d8">
          <LabelList dataKey="count" position="top" />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}

export default Top10Graph
